import React, { useState, useRef, useEffect  } from "react";
import ph_plus from "../../assets/img/ph_plus.svg";
import logo from "../../assets/img/breezemind-logo.png";
import pencil from "../../assets/img/pencil.png";
import deleteimg from "../../assets/img/delete.png";
import loading_circle from "../../assets/img/1488.gif";
//import { handleDeleteClick } from '../ChatBox/functions';  // Import the handler

interface QuestionItem {
  knowledge_set: string;
  metadata: {
    conversation: {
      title?: string;
    };
    insert_date: string;
  };
}

interface LeftPanelProps {
  questionList: QuestionItem[];
  activeConv: string;
  handleCreateTask: () => void;
  handleConvClick: (
    knowledge_set: string,
    convClick: boolean,
    title?: string
  ) => void;
  formatTimeDifference: (date: any) => string;
  onSaveTitle: (id: string, newTitle: string) => void;
  deleteConversation: (id: string) => void;
}

const ConvList: React.FC<LeftPanelProps> = ({
  questionList,
  activeConv,
  handleCreateTask,
  handleConvClick,
  formatTimeDifference,
  onSaveTitle,
  deleteConversation
}) => {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [title, setTitle] = useState<string>("");

  const editableRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    if (editingId) {
      const element = editableRef.current;
      if (element) {
        element.focus();
        // Move cursor to end of text
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(element);
       // range.collapse(false);
        range.collapse(true);
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }
  }, [editingId]);

  const handleEditClick = (id: string, currentTitle: string) => {
    setEditingId(id);
    setTitle(currentTitle || "Untitled Task");
  };

  const handleDeleteClick = (id: string) => {
    
        deleteConversation(id);

  };
  

  const handleOnBlur = (event: React.FocusEvent<HTMLAnchorElement>,id: string) => {
    // console.log("On Blur Function called");
    // console.log(event.currentTarget.textContent);
    if (!editingId) return; // Do nothing if not editing

    // Check if blur happened due to clicking outside the element
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (relatedTarget && relatedTarget.classList.contains("edit-title-button")) {
     // console.log("Clicked on edit button");
      event.preventDefault(); // Ignore if clicking on the edit button
      return;
    }
    handleBlur(id,event.currentTarget.textContent || "");
  };

  const handleBlur = (id: string, title: string) => {
    if (title.trim() !== "") {
      onSaveTitle(id, title);
    }
    setEditingId(null);
  };

  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLAnchorElement> | React.FormEvent<HTMLAnchorElement>,
    id: string
  ) => {
   // console.log("Out");
    if (event.type === "keypress" && (event as React.KeyboardEvent).key === "Enter") {
      event.preventDefault();
      //console.log("In");
      // Retrieve the value of the anchor tag or any other required operation
      const anchorValue = (event.target as HTMLAnchorElement).textContent || "";
      //console.log(anchorValue); // Use the anchor value as needed

      (event.target as HTMLAnchorElement).blur();

  
      // Call your handleBlur function if needed
  //       handleBlur(id,anchorValue);
    }
  };

  const handleInput = (event: React.FormEvent<HTMLAnchorElement>) => {
   // console.log(event.currentTarget.textContent);
    //setTitle(event.currentTarget.textContent || "");
  };

  

  const handleSpanClick = (event: React.MouseEvent<HTMLSpanElement>,item: QuestionItem) => {
    //console.log("span : editingId is "+editingId);
    if (editingId === null) {
      handleConvClick(
        item.knowledge_set,
        true,
        item.metadata.conversation.title
      );
    }else{
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>,item: QuestionItem) => {
   // console.log("editingId is "+editingId);
    if (editingId === null) {
      handleConvClick(
        item.knowledge_set,
        true,
        item.metadata.conversation.title
      );
    }else{
      event.preventDefault();
      event.stopPropagation();
    }
  };


  return (
    <div className="left_panel panel">
      <div className="left_panel_inner">
      <div className="back_bar"><a href="/my-account/">&lt;&lt; Back to Dashboard</a></div>
        <div className="chat">
          <div className="top_bar">
            <div className="left_part">
              <span className="user_img">
              <img src={logo} alt="User" />
              </span>
            </div>
            <div className="right_part" onClick={handleCreateTask}>
              <img className="add_icon" id="add_icon" src={ph_plus} alt="read" />
            </div>
          </div>
          <div className="bottom_bar">
            <ul className="question_list">
              {questionList.map((item: any) => (
                <li
                  key={item.knowledge_set}
                  className={`item ${
                    activeConv === item.knowledge_set ? "active" : ""
                  }`}
                  
                >
                  <div className="conversation_title d-flex align-items-center justify-content-between">
                  <a
                      href="#"
                      className="chat-title"
                      contentEditable={editingId === item.knowledge_set}
                      suppressContentEditableWarning={true}
                      onBlur={(e) => handleOnBlur(e, item.knowledge_set)}
                      onInput={handleInput}
                      onKeyPress={(e) => handleKeyPress(e, item.knowledge_set)}
                     // onClick={(e) => e.stopPropagation()} // Prevents click event from bubbling up
                     onClick={(e) => handleClick(e,item)}
                      ref={editingId === item.knowledge_set ? editableRef : null}
                     
                    >
                      {editingId === item.knowledge_set
                        ? title
                        : item.metadata.conversation.title || "Untitled Task"}
                    </a>
                   
                    <img
                      className="edit-title-button"
                      src={pencil}
                      alt="Edit"
                      onClick={() => handleEditClick(item.knowledge_set, item.metadata.conversation.title || "Untitled Task")}
                    />
                    <img
                      className="delete-button"
                      id={"delete-button-" + item.knowledge_set}
                      src={deleteimg}
                      alt="Delete"
                      onClick={() => handleDeleteClick(item.knowledge_set)}
                    />
                    <img src={loading_circle} className="del_loading_gif" id={"del_loading_gif_" + item.knowledge_set}></img>
                  </div>
                  <div> <span className="conversation_time" onClick={(e) => handleSpanClick(e,item)}>
                      {formatTimeDifference(item.metadata.insert_date)}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvList;